import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {UserCareProgram, UserCareProgramModuleEntry} from "@shared/api/models/query/user-care-program.model";
import {environment} from "../../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class UserCareProgramsService extends PaginatorService<UserCareProgram> {

    protected override get domainEntity() {
        return 'user-care-programs';
    };

    getModules(userCareProgramId: number): Observable<UserCareProgramModuleEntry[]> {
        const url = `${environment.baseApiUrl}v2/user-care-programs/${userCareProgramId}/modules?size=999&start=0`;
        return this.http.get<{data: UserCareProgramModuleEntry[]}>(url)
            .pipe(map(res => res?.data ?? []));
    }

    getModule(userCareProgramId: number, moduleId: number): Observable<UserCareProgramModuleEntry> {
        const url = `${environment.baseApiUrl}v2/user-care-programs/${userCareProgramId}/modules/${moduleId}`;
        return this.http.get<{data: UserCareProgramModuleEntry}>(url)
            .pipe(map(res => res.data));
    }
}
